/**
 * Customer-message sentiment, classified once per question at LLM-block time and
 * stored on `llm_usages.sentiment`. Drives the Home v2 Intelligence sentiment bar
 * (aggregated per topic) and the per-question badges in the topic View modal.
 *
 * Shared across Core (classifier + storage), Backend (aggregation), and REST contracts.
 */
export enum Sentiment {
  Unhappy = 'unhappy',
  Neutral = 'neutral',
  Happy = 'happy',
}

// Used when the classifier fails, returns an empty/unknown label, or for any
// message that cannot be confidently scored. Neutral is the safe middle default.
export const SENTIMENT_FALLBACK: Sentiment = Sentiment.Neutral;

// All valid string values - used to validate/sanitize raw classifier output.
export const SENTIMENT_VALUES: readonly Sentiment[] = Object.values(Sentiment);
